import { render, staticRenderFns } from "./MyDeliveryTheQuery.vue?vue&type=template&id=3b2c7c3c&scoped=true"
import script from "./MyDeliveryTheQuery.vue?vue&type=script&lang=js"
export * from "./MyDeliveryTheQuery.vue?vue&type=script&lang=js"
import style0 from "./MyDeliveryTheQuery.vue?vue&type=style&index=0&id=3b2c7c3c&prod&scoped=true&lang=scss"
import style1 from "./MyDeliveryTheQuery.vue?vue&type=style&index=1&id=3b2c7c3c&prod&lang=css"
import style2 from "./MyDeliveryTheQuery.vue?vue&type=style&index=2&id=3b2c7c3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2c7c3c",
  null
  
)

export default component.exports